import { render } from "./courses.vue?vue&type=template&id=36ba72ee&scoped=true"
import script from "./courses.vue?vue&type=script&lang=js"
export * from "./courses.vue?vue&type=script&lang=js"

import "./courses.vue?vue&type=style&index=0&id=36ba72ee&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ba72ee"]])

export default __exports__